import React from "react";
import { Link } from "gatsby";
import Container from "./container";
import NewsCard from "./news-card";
import { cn } from "../lib/helpers";
import Icon from "./icon";

import * as styles from "../styles/components/related.module.css";

const NewsSection = (props) => {

  const {
    heading,
    link,
    news
  } = props;

  return (
    <div className={styles.root}>
      <Container>
        {heading && <h2 className={cn("h3", styles.heading)}>{heading}</h2>}
        {link && link.url && 
          <>
            {link.blank
              ? <a href={link.url} className="link" target="_blank" rel="noreferrer">{link.text}<Icon symbol="arrow-right" /></a>
              : <Link to={link.url} className="link">{link.text}<Icon symbol="arrow-right" /></Link>
            }
          </>
        }
        {(news && news.length) 
          ? <div className={cn("grid", styles.items)}>
              {news.map(({ news, _key }) => {
                return (
                  <div key={_key} className={cn("col-12 col-md-6 col-xl-4", styles.item)}>
                    <NewsCard news={news} />
                  </div>
                );
              })}
            </div>
          : null
        }
      </Container>
    </div>
  );
}

export default NewsSection;
